import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import ProductManager from '../components/Admin/ProductManager';
import ServiceManager from '../components/Admin/ServiceManager';

export default function Admin() {
  const [activeTab, setActiveTab] = useState('products');

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">Admin Dashboard</h1>
          <p className="text-gray-600">Manage your products and services</p>
        </div>

        {/* Tab Navigation */}
        <div className="flex gap-4 mb-8 bg-white p-2 rounded-lg shadow-sm">
          <Button
            onClick={() => setActiveTab('products')}
            variant={activeTab === 'products' ? 'default' : 'outline'}
            className={`flex-1 sm:flex-none ${activeTab === 'products' ? 'bg-blue-600 hover:bg-blue-700 text-white' : ''}`}
          >
            Products
          </Button>
          <Button
            onClick={() => setActiveTab('services')}
            variant={activeTab === 'services' ? 'default' : 'outline'}
            className={`flex-1 sm:flex-none ${activeTab === 'services' ? 'bg-blue-600 hover:bg-blue-700 text-white' : ''}`}
          >
            Services
          </Button>
        </div>

        {/* Tab Content */}
        {activeTab === 'products' && (
          <ProductManager />
        )}

        {activeTab === 'services' && (
          <ServiceManager />
        )}
      </div>
    </div>
  );
}